import React, { useState, useEffect } from 'react';
import { FileText } from 'lucide-react';
import { getProjectThumbnailUrl } from '../../services/revisions';

interface ProjectThumbnailProps {
  projectId: string;
  onClick?: () => void;
}

export function ProjectThumbnail({ projectId, onClick }: ProjectThumbnailProps) {
  const [thumbnailUrl, setThumbnailUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let mounted = true;

    async function loadThumbnail() {
      try {
        const url = await getProjectThumbnailUrl(projectId);
        if (mounted) {
          setThumbnailUrl(url);
          setLoading(false);
        }
      } catch {
        if (mounted) {
          setError(true);
          setLoading(false);
        }
      }
    }

    loadThumbnail();

    return () => {
      mounted = false;
    };
  }, [projectId]);

  return (
    <div
      onClick={onClick}
      className="h-36 bg-gray-100 rounded-t-lg flex items-center justify-center cursor-pointer overflow-hidden"
    >
      {loading ? (
        <div className="animate-pulse bg-gray-200 w-full h-full" />
      ) : thumbnailUrl && !error ? (
        <img
          src={thumbnailUrl}
          alt="Project preview"
          className="w-full h-full object-cover object-top"
          onError={() => setError(true)}
        />
      ) : (
        <FileText className="h-12 w-12 text-gray-300" />
      )}
    </div>
  );
}
